import { Clinic } from "pwapi";

import { formatPhone } from "./patientUtils";

export const isTenDigitNumeric = (value: string): boolean => {
  const trimmed = value.trim();
  return /^\d{10}$/.test(trimmed);
};

export const getClinicPhone = (clinic: Clinic): string | false => {
  if (clinic?.phone) {
    return isTenDigitNumeric(clinic.phone)
      ? formatPhone(clinic.phone)
      : clinic.phone;
  }
  if (clinic?.location?.phone1) {
    return isTenDigitNumeric(clinic.location.phone1)
      ? formatPhone(clinic.location.phone1)
      : clinic.location.phone1;
  }
  if (clinic?.location?.phone2) {
    return isTenDigitNumeric(clinic.location.phone2)
      ? formatPhone(clinic.location.phone2)
      : clinic.location.phone2;
  }
  return false;
};
